module.exports = __webpack_public_path__ + "img/power_factor.446a2197.png";